import { useEffect, useState } from "react";
import { Cookies } from 'react-cookie';
import { useNavigate } from "react-router-dom";
import { API_SERVER } from '../../EnvConfig/env_config';
import { setFocus } from "../Common/Common";
import { AlertBox } from '../Common/Input';
import { post } from "../Common/service";
import Loader from '../Layout/Loader';
const cookies = new Cookies();

const ConfigurationSettings = ({ open }) => {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');

    const [formData, setFormData] = useState({
        isMobileOTP: true
    });

    const data = {
        Token: Token,
        LoginUserCode: LoginUserCode ? String(LoginUserCode) : "",
        Source: 'web'
    }

    const handleSubmit = async () => {
        setIsLoading(true)
        post(`${API_SERVER}/api/Dashboard/UpdateConfiguration`, { ...data, ...formData }, (res) => {
            if (res.status === "SUCCESS") {
                setIsLoading(false);
                AlertBox(res.status, res.message, res.focus);
                setIsLoading(false)
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                setIsLoading(false)
                AlertBox(res.status, res.message, res.focus);
            }
        })
        setIsLoading(false)
    };

    const GetConfigrationData = async (id) => {
        post(`${API_SERVER}/api/Dashboard/GetConfiguration`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setFormData({ ...formData, isMobileOTP: res.active });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
        })
    }

    useEffect(() => {
        GetConfigrationData()
        document.title = 'Configuration Settings'
        setFocus("txtIsMobileOTP")
    }, [])

    return (
        <>
            <main id="main" className={`main ${open ? '' : 'margin_left'}`}  >
                <section className="section dashboard">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="content-box">
                                <h5 className='ps-3 pt-3'>Configuration Settings</h5>
                                <div className="form-box service-content-area">
                                    <div className="row align-items-end">
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="form-check form-switch">
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="activeCheckbox"
                                                >
                                                    Mobile OTP Applicable
                                                </label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="txtIsMobileOTP"
                                                    name='IsMobileOTP'
                                                    checked={formData.isMobileOTP}
                                                    onChange={(e) => setFormData({ ...formData, isMobileOTP: e.target.checked })}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            handleSubmit()
                                                        };
                                                    }}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="lms-new-button text-center">
                                                <button className="button save-btn" onClick={handleSubmit}>
                                                    <i className="bi bi-check-lg" /> Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
            </main>
        </>
    )
}
export default ConfigurationSettings;